import { FormControlLabel, Switch } from '@presov.sk/presov-ui-react';
import React from 'react';
import { Field } from 'react-final-form';

type Props = {
  name: string;
  label?: string;
};

/**
 * Samotný prepínač do vlastnej kompozície - tu ho obklopuje riadok s titulom
 * a popisom, ktorý si kreslí `NotificationsSettings`.
 *
 * Booleovské nastavenie, ktoré stojí samo, je `SwitchField` z knižnice
 * (ohraničený riadok s popisom) - nie toto.
 */
const FormSwitchControl: React.FC<Props> = ({ name, label }) => {
  return (
    <Field name={name} type='checkbox'>
      {({ input: { value, onChange } }) => {
        return (
          <FormControlLabel
            control={<Switch checked={value} onChange={onChange} />}
            label={label}
          />
        );
      }}
    </Field>
  );
};

export default FormSwitchControl;
